import script from "./ForecastWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./ForecastWidget.vue?vue&type=script&setup=true&lang=ts"

import "./ForecastWidget.vue?vue&type=style&index=0&id=1befe26c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1befe26c"]])

export default __exports__